import { render, staticRenderFns } from "./BuildingCreateModal.vue?vue&type=template&id=b988e2aa&"
import script from "./BuildingCreateModal.vue?vue&type=script&lang=js&"
export * from "./BuildingCreateModal.vue?vue&type=script&lang=js&"
import style0 from "./BuildingCreateModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports